import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-holidaycalendar-grid',
  templateUrl: './holidaycalendar-grid.component.html',
  styleUrls: ['./holidaycalendar-grid.component.css']
})
export class HolidaycalendarGridComponent implements OnInit {

  title="View Holidays";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/master/holidaycalendar/holidaycalendar-grid/holidaycalendar-grid.component.ts